import * as v from "valibot";
import { rpcContract } from "../rpc";

export const checkFeatureFlagRpcContract = rpcContract({
  name: "check-feature-flag",
  paramsSchema: v.object({
    featureName: v.string(),
  }),
  resultSchema: v.object({
    enabled: v.boolean(),
    featureName: v.string(),
  }),
});

export type CheckFeatureFlagParams = v.InferOutput<(typeof checkFeatureFlagRpcContract)["paramsSchema"]>;
export type CheckFeatureFlagResult = v.InferOutput<(typeof checkFeatureFlagRpcContract)["resultSchema"]>;

export const getMyFeatureFlagsRpcContract = rpcContract({
  name: "get-my-feature-flags",
  paramsSchema: v.object({}),
  resultSchema: v.object({
    features: v.array(v.string()),
  }),
});

export type GetMyFeatureFlagsParams = v.InferOutput<(typeof getMyFeatureFlagsRpcContract)["paramsSchema"]>;
export type GetMyFeatureFlagsResult = v.InferOutput<(typeof getMyFeatureFlagsRpcContract)["resultSchema"]>;

export const enableFeatureForUsersRpcContract = rpcContract({
  name: "enable-feature-for-users",
  paramsSchema: v.object({
    featureName: v.string(),
    userIds: v.array(v.string()),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    updatedCount: v.number(),
  }),
});

export type EnableFeatureForUsersParams = v.InferOutput<(typeof enableFeatureForUsersRpcContract)["paramsSchema"]>;
export type EnableFeatureForUsersResult = v.InferOutput<(typeof enableFeatureForUsersRpcContract)["resultSchema"]>;

export const disableFeatureForUsersRpcContract = rpcContract({
  name: "disable-feature-for-users",
  paramsSchema: v.object({
    featureName: v.string(),
    userIds: v.array(v.string()),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    updatedCount: v.number(),
  }),
});

export type DisableFeatureForUsersParams = v.InferOutput<(typeof disableFeatureForUsersRpcContract)["paramsSchema"]>;
export type DisableFeatureForUsersResult = v.InferOutput<(typeof disableFeatureForUsersRpcContract)["resultSchema"]>;

export const enableFeatureByEmailsRpcContract = rpcContract({
  name: "enable-feature-by-emails",
  paramsSchema: v.object({
    featureName: v.string(),
    emails: v.array(v.pipe(v.string(), v.email())),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    updatedCount: v.number(),
    notFoundEmails: v.array(v.string()),
  }),
});

export type EnableFeatureByEmailsParams = v.InferOutput<(typeof enableFeatureByEmailsRpcContract)["paramsSchema"]>;
export type EnableFeatureByEmailsResult = v.InferOutput<(typeof enableFeatureByEmailsRpcContract)["resultSchema"]>;

export const disableFeatureByEmailsRpcContract = rpcContract({
  name: "disable-feature-by-emails",
  paramsSchema: v.object({
    featureName: v.string(),
    emails: v.array(v.pipe(v.string(), v.email())),
  }),
  resultSchema: v.object({
    success: v.boolean(),
    updatedCount: v.number(),
    notFoundEmails: v.array(v.string()),
  }),
});

export type DisableFeatureByEmailsParams = v.InferOutput<(typeof disableFeatureByEmailsRpcContract)["paramsSchema"]>;
export type DisableFeatureByEmailsResult = v.InferOutput<(typeof disableFeatureByEmailsRpcContract)["resultSchema"]>;
